import { render, staticRenderFns } from "./NewDecoComponent.vue?vue&type=template&id=86daf5c0&"
import script from "./NewDecoComponent.vue?vue&type=script&lang=ts&"
export * from "./NewDecoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports